import colors from "@/colors"

export const chartColors = {
  darkBlue: colors.blue["700"],
  darkOrange: "#c47720",
  judicialClerkship: colors.indigo["400"],
  largeFirm: colors.blue["900"],
  mediumBlue: "#84aad3",
  nonEmployed: colors.orange["500"],
  otherJobs: colors.gray["500"],
  publicService: colors.yellow["500"],
  regionalFirm: colors.blue["800"],
  smallFirm: colors.blue["700"],
}
